import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import CapacitorUpdatePopup from "./CapacitorUpdatePopup";
import { CapacitorUpdateLoader } from "@components/loader/mobile";
import { isCapacitorPlatform } from "@utils/specific/capacitor";

export const CapacitorUpdateContainer = observer(
	function CapacitorUpdateContainer() {
		const { capacitorUpdaterStore } = useRootAppStore();

		if (isCapacitorPlatform() && capacitorUpdaterStore.isPopupVisible) {
			return <CapacitorUpdatePopup />;
		}

		if (isCapacitorPlatform() && capacitorUpdaterStore.isLoading) {
			return <CapacitorUpdateLoader />;
		}

		return null;
	}
);
